export enum FileDownloadMode {
  SingleFileUsingDropdown,
  SingleFileUsingChip,
  AllFiles
}
